<template>
  <fieldset
    :class="[
      'db-tw-w-[90vw] db-tw-mb-6 db-tw-pb-2.5 db-tw-overflow-scroll md:db-tw-m-0 md:db-tw-pb-0 md:db-tw-w-full md:db-tw-overflow-auto',
      {
        'db-has-error': v$.field.$error,
      },
    ]"
  >
    <legend class="db-label">
      <span>
        {{ labelRoomSetup }}
        <span
          v-if="isMandatory"
          class="db-input-required-indicator"
        >
          *
        </span>
      </span>
    </legend>
    <DbWrapperRadioIcon
      :modelValue="modelValue"
      :checkbox="checkbox"
      v-on:update:model-value="$emit('update:modelValue', $event)"
    />
    <div
      v-if="v$.field.$error"
      class="db-label"
    >
      <DbRfpErrors :errors="v$.field.$errors" />
    </div>
  </fieldset>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { requiredIf } from '@/utils/i18n-validators'
import type { RoomSetupOptions } from './RfpGroupRoomSetupTypes'

const props = withDefaults(
  defineProps<{
    modelValue?: string
    labelRoomSetup: string
    checkbox: RoomSetupOptions
    isMandatory: boolean
  }>(),
  {
    modelValue: '',
  },
)

defineEmits<{
  (e: 'update:modelValue', modelValue: string | number): void
}>()

const state = computed(() => {
  return {
    field: props.modelValue,
  }
})

const rules = computed(() => {
  return {
    field: { required: requiredIf(props.isMandatory) },
  }
})

const v$ = useVuelidate(rules, state, { $autoDirty: true })
</script>
